export const onsiteConfig = { 
    defaultItem: {
        onsiteForm: {
            upperPressure: {
                field: 'upperPressure',
                title: 'ความดันตัวบน (มม.ปรอท)',
                type: 'number'
            },
            lowerPressure: {
                field: 'lowerPressure',
                title: 'ความดันตัวล่าง (มม.ปรอท)',
                type: 'number'
            },
            hr: {
                field: 'hr',
                title: 'ชีพจรขณะพัก (ครั้ง/นาที)',
                type: 'number'
            },
            weight: {
                field: 'weight',
                title: 'น้ำหนักตัว (กก.)',
                type: 'number'
            },
            bmi: {
                field: 'bmi',
                title: 'BMI',
                type: 'number'
            },
            waist: {
                field: 'waist',
                title: 'รอบเอว (ซม.)',
                type: 'number'
            },
            hip: {
                field: 'hip',
                title: 'รอบสะโพก (ซม.)',
                type: 'number'
            },
            whr: {
                field: 'whr',
                title: 'สัดส่วนรอบเอวต่อรอบสะโพก',
                type: 'number'
            },
            intakeCalories: {
                field: 'intakeCalories',
                title: 'ปริมาณพลังงานเข้าจากอาหารที่แนะนำ (แคลอรี่)',
                type: 'number'
            },
            outtakeCalories: {
                field: 'outtakeCalories',
                title: 'ปริมาณพลังงานที่ใช้ TDEE (แคลอรี่)',
                type: 'number'
            },
            sitToStandTitle: {
                title: 'ความแข็งแรงและความทนทานของกล้ามเนื้อ (Muscle strength and durance fitness)'
            },
            sitToStand: {
                field: 'sitToStand',
                title: 'ผลการทดสอบ Sit-to-stand (ครั้ง)',
                type: 'number'
            },
            pushUp: {
                field: 'pushUp',
                title: 'ผลการทดสอบ push-up test (ครั้ง)',
                type: 'number'
            },
            walk6MinutesTitle: {
                title: "สมรรถภาพของระบบไหลเวียนโลหิตและหายใจ (Cardiovascular endurance)"
            },  
            walk6MinutesTestDistance: {
                field: 'walk6MinutesTestDistance',
                title: "ระยะทาง (เมตร)",
                type: 'number'
            },
            walk6MinutesTestVO2Max: {
                field: 'walk6MinutesTestVO2Max',
                title: "VO2 Max",
                type: 'number'
            },
            walk6MinutesTestHR: {
                field: 'walk6MinutesTestHR',
                title: "อัตราการเต้นของหัวใจตอนหยุด (ครั้ง/นาที)",
                type: 'number'
            },
            ymcaTitle: {
                title: 'ความอ่อนตัว (Flexibility)'
            },
            ymca: {
                field: 'ymca',
                title: 'การทดสอบ YMCA หรือ V-sit-and-reach (นิ้ว)',
                type: 'number'
            },
            backScratchRightHandTest: {
                field: 'backScratchRightHandTest',
                title: 'ผลการทดสอบ Back-scratch test มือขวาอยู่บน (นิ้ว)',
                type: 'number'
            },
            backScratchLeftHandTest: {
                field: 'backScratchLeftHandTest',
                title: 'ผลการทดสอบ Back-scratch test มือซ้ายอยู่บน (นิ้ว)',
                type: 'number'
            },
            balance:{
                title: 'การทรงตัว (Balance)'
            },
            singleLegBalance: {
                field: 'singleLegBalance',
                title: 'ผลการทดสอบ ยืนขาเดียว (วินาที)',
                type: 'number'
            },
            note: {
                title: 'เพิ่มเติม'
            },
            assignment: {
                field: 'assignment',
                title: 'การบ้านจากโค้ช',
                type: 'textarea'
            },
            recommendation: {
                field: 'recommendation',
                title: 'แนะนำเพิ่มเติม',
                type: 'textarea'
            }
        },
        onsiteReport: {
            date: {
                field: 'date',
                title: 'วันที่'
            },
            upperPressure: {
                field: 'upperPressure',
                title: 'ความดันตัวบน (มม.ปรอท)'
            },
            lowerPressure: {
                field: 'lowerPressure',
                title: 'ความดันตัวล่าง (มม.ปรอท)'
            },
            hr: {
                field: 'hr',
                title: 'ชีพจรขณะพัก (ครั้ง/นาที)'
            },
            weight: {
                field: 'weight',
                title: 'น้ำหนักตัว (กก.)'
            },
            bmi: {
                field: 'bmi',
                title: 'BMI'
            },
            waist: {
                field: 'waist',
                title: 'รอบเอว (ซม.)'
            },
            hip: {
                field: 'hip',
                title: 'รอบสะโพก (ซม.)'
            },
            whr: {
                field: 'whr',
                title: 'สัดส่วนรอบเอวต่อรอบสะโพก'
            },
            intakeCalories: {
                field: 'intakeCalories',
                title: 'ปริมาณพลังงานเข้าจากอาหารที่แนะนำ (แคลอรี่)'
            },
            outtakeCalories: {
                field: 'outtakeCalories',
                title: 'ปริมาณพลังงานที่ใช้ TDEE (แคลอรี่)'
            },
            sitToStandTitle: {
                title: 'ความแข็งแรงและความทนทานของกล้ามเนื้อ (Muscle strength and durance fitness)'
            },
            sitToStand: {
                field: 'sitToStand',
                title: 'ผลการทดสอบ Sit-to-stand (ครั้ง)'
            },
            pushUp: {
                field: 'pushUp',
                title: 'ผลการทดสอบ push-up test (ครั้ง)'
            },
            walk6MinutesTitle: {
                title: "สมรรถภาพของระบบไหลเวียนโลหิตและหายใจ (Cardiovascular endurance)"
            },  
            walk6MinutesTestDistance: {
                field: 'walk6MinutesTestDistance',
                title: "ระยะทาง (เมตร)"
            },
            walk6MinutesTestVO2Max: {
                field: 'walk6MinutesTestVO2Max',
                title: "VO2 Max"
            },
            walk6MinutesTestHR: {
                field: 'walk6MinutesTestHR',
                title: "อัตราการเต้นของหัวใจตอนหยุด (ครั้ง/นาที)"
            },
            ymcaTitle: {
                title: 'ความอ่อนตัว (Flexibility)'
            },
            ymca: {
                field: 'ymca',
                title: 'การทดสอบ YMCA หรือ V-sit-and-reach (นิ้ว)'
            },
            // backScratchTest: {
            //     title: 'ผลการทดสอบ Back-scratch test'
            // },
            backScratchRightHandTest: {
                field: 'backScratchRightHandTest',
                title: 'ผลการทดสอบ Back-scratch test มือขวาอยู่บน (นิ้ว)'
            },
            backScratchLeftHandTest: {
                field: 'backScratchLeftHandTest',
                title: 'ผลการทดสอบ Back-scratch test มือซ้ายอยู่บน (นิ้ว)'
            },
            balance:{
                title: 'การทรงตัว (Balance)'
            },
            singleLegBalance: {
                field: 'singleLegBalance',
                title: 'ผลการทดสอบ ยืนขาเดียว (วินาที)'
            }
        }
    },
    target: {
        upperPressure: {
            male: '120',
            female: '120'
        },
        lowerPressure: {
            male: '80',
            female: '80'
        },
        hr: {
            male: '80',
            female: '80'
        },
        bmi: {
            male: '23',
            female: '23'
        },
        weight: {
            male: 'x',
            female: 'x'
        },
        intakeCalories: {
            male: '0',
            female: '0',
        },
        outtakeCalories: {
            male: '0',
            female: '0',
        },
        hip: {
            male: 'x',
            female: 'x'
        },
        waist: {
            male: '90',
            female: '80'
        },
        walk6MinutesTestVO2Max: {
            male: '0',
            female: '0'
        },
        walk6MinutesTestHR : {
            male: '0',
            female: '0'
        },
        whr: {
            male: {
                '18-29': '0.83',
                '30-39': '0.84',
                '40-49': '0.88',
                '50-59': '0.90',
                '60-100': '0.91'
            },
            female: {
                '18-29': '0.71',
                '30-39': '0.72',
                '40-49': '0.73',
                '50-59': '0.74',
                '60-100': '0.76'
            },
        },
        sitToStand: {
            male: {
                '19-24': '39',
                '25-29': '39',
                '30-34': '34',
                '35-39': '34',
                '40-44': '33',
                '45-49': '30',
                '50-54': '28',
                '55-59': '26'
            },
            female: {
                '19-24': '33',
                '25-29': '31',
                '30-34': '30',
                '35-39': '29',
                '40-44': '27',
                '45-49': '23',
                '50-54': '19',
                '55-59': '18'
            },
        },
        pushUp: {
            male: {
                '18-29': '37',
                '30-39': '27',
                '40-49': '22',
                '50-59': '17',
                '60-100': '11'
            },
            female: {
                '18-29': '32',
                '30-39': '22',
                '40-49': '17',
                '50-59': '11',
                '60-100': '10'
            },
        },
        walk6MinutesTestDistance: {
            male: '576',
            female: '494'
        },
        ymca: {
            male: {
                '17-19': '14',
                '20-29': '15',
                '30-39': '13',
                '40-49': '11',
                '50-59': '11',
                '60-69': '9'
            },
            female: {
                '17-19': '14',
                '20-29': '14',
                '30-39': '14',
                '40-49': '13',
                '50-59': '14',
                '60-69': '14'
            },
        },
        backScratchLeftHandTest : {
            male: '0',
            female: '0'
        },
        backScratchRightHandTest : {
            male: '0',
            female: '0'
        },
        singleLegBalance: {
            male: {
                '18-39': '43',
                '40-49': '40.3',
                '50-59': '37',
                '60-69': '26.9'
            },
            female: {
                '18-39': '43',
                '40-49': '40.3',
                '50-59': '37',
                '60-69': '26.9'
            }
        },
    },
    survey: {
        SugarTest: {
            title: 'กินหวาน',
            riskPoint: {
                '0-5': 'ปกติ',
                '6-9': 'เสี่ยงปานกลาง',
                '10-100': 'เสี่ยงสูง'
            }
        },
        FatTest: {
            title: 'กินไขมัน',
            riskPoint: {
                '0-5': 'ปกติ',
                '6-9': 'เสี่ยงปานกลาง',
                '10-100': 'เสี่ยงสูง'
            }
        },
        SodiumTest: {
            title: 'กินโซเดียม',
            riskPoint: {
                '0-5': 'ปกติ',
                '6-9': 'เสี่ยงปานกลาง',
                '10-100': 'เสี่ยงสูง'
            }
        },
        VegetableTest: {
            title: 'กินผักผลไม้',
            riskPoint: {
                '3-3': 'เสี่ยงสูง',
                '4-4': 'เสี่ยงปานกลาง',
                '5-5': 'ปกติ',
            }
        },
        AlcoholTest: {
            title: 'ดื่มเหล้า',
            riskPoint: {
                '0-10': 'ปกติ',
                '11-26': 'เสี่ยงปานกลาง',
                '27-100': 'เสี่ยงสูง'
            }
        },
        AlcoholTestFreq: {
            title: 'ความถี่ดื่มเหล้า'
        },
        SmokeTest: {
            title: 'สูบบุหรี่',
            riskPoint: {
                '0-3': 'ปกติ',
                '4-5': 'เสี่ยงปานกลาง',
                '6-100': 'เสี่ยงสูง'
            }
        },
        SmokeTestFreq: {
            title: 'ความถี่สูบบุหรี่'
        },
        StressTest: {
            title: 'ความเครียด',
            riskPoint: {
                '0-4': 'ปกติ',
                '5-7': 'เสี่ยงปานกลาง',
                '8-100': 'เสี่ยงสูง'
            }
        },
        PerceiveTest: {
            title: 'การรับรู้ในตน',
            riskPoint: {
                '0-100': 'ปกติ'
            }
        }
    }
};
